import { defineMessage } from 'react-intl';

export const statusMessages = {
  online: defineMessage({
    id: `logger.status.filter.online`,
    defaultMessage: 'Online',
  }),
  offline: defineMessage({
    id: `logger.status.filter.offline`,
    defaultMessage: 'Offline',
  }),
};

export enum StatusFilterType {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

/** Filter values for station type: radio, non-YouTube TV, or YouTube Native. */
export enum StationTypeFilterType {
  RADIO = 'radio',
  TV = 'tv',
  YOUTUBE = 'youtube',
}

/** Filter values for station ownership: owned by the client or shared from another. */
export enum StationAccessFilterType {
  OWNED = 'owned',
  SHARED = 'shared',
}

/** Labels for the station type filter toggles (tooltips and accessible names). */
export const stationTypeMessages = {
  radio: defineMessage({
    id: 'logger.statusScreen.stationTypeRadio',
    defaultMessage: 'Radio',
  }),
  tv: defineMessage({
    id: 'logger.statusScreen.stationTypeTv',
    defaultMessage: 'TV',
  }),
  youtube: defineMessage({
    id: 'logger.statusScreen.stationTypeYoutube',
    defaultMessage: 'YouTube',
  }),
};

/** Labels for the station access filter toggles (tooltips and accessible names). */
export const stationAccessMessages = {
  owned: defineMessage({
    id: 'logger.statusScreen.stationAccessOwned',
    defaultMessage: 'Mis emisoras',
  }),
  shared: defineMessage({
    id: 'logger.statusScreen.stationAccessShared',
    defaultMessage: 'Emisoras externas',
  }),
};
